module.exports = __webpack_public_path__ + "07d49a6f4aa47746c09e16988020988b.svg";